export default function Support() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-14">
      <h1 className="text-4xl font-extrabold mb-2">Destek</h1>
      <p className="text-textSecondary mb-8">
        Bir sorun mu var? Öneri mi vereceksin? Aşağıdaki kanallardan bize
        ulaşabilirsin.
      </p>

      <div className="grid sm:grid-cols-2 gap-4">
        <SupportCard
          icon="📧"
          title="E-posta"
          body="info@zyronajans.com"
          action={
            <a
              className="btn-outline mt-4 w-full"
              href="mailto:info@zyronajans.com"
            >
              Yazmaya başla
            </a>
          }
        />
        <SupportCard
          icon="🔐"
          title="Hesabımı silmek istiyorum"
          body="Uygulama içinde Ayarlar → Hesabı Sil seçeneğini kullan. Uygulamayı açamıyorsan bu sayfadaki e-postadan talep oluştur, kimlik doğrulandıktan sonra 30 gün içinde verin silinir."
        />
        <SupportCard
          icon="🚩"
          title="Oyuncu şikayeti"
          body="Taciz, hile veya uygunsuz kullanıcı adı tespit edersen oyun sonu ekranındaki bayrak butonuyla bildir. Moderasyon ekibi 48 saat içinde yanıt verir."
        />
        <SupportCard
          icon="🛡️"
          title="Güvenlik açığı"
          body="Responsible disclosure: bir zafiyet bulursan kamu paylaşımı yapmadan önce e-posta gönder. 7 gün içinde geri dönüş yapıyoruz."
        />
      </div>

      <div className="card p-6 mt-10">
        <h2 className="font-extrabold mb-2">Yanıt süreleri</h2>
        <ul className="text-sm text-textSecondary space-y-1">
          <li>• Genel destek: 2 iş günü içinde</li>
          <li>• Hesap silme talebi: 7 gün içinde başlatılır, 30 gün içinde tamamlanır</li>
          <li>• KVKK/GDPR veri talepleri: 30 gün (yasal süre)</li>
          <li>• Güvenlik açığı: 7 gün içinde</li>
        </ul>
      </div>
    </div>
  );
}

function SupportCard({
  icon,
  title,
  body,
  action,
}: {
  icon: string;
  title: string;
  body: string;
  action?: React.ReactNode;
}) {
  return (
    <div className="card p-6">
      <div className="text-3xl mb-2">{icon}</div>
      <h3 className="font-extrabold mb-1">{title}</h3>
      <p className="text-sm text-textSecondary leading-relaxed">{body}</p>
      {action}
    </div>
  );
}
